import React, { useEffect, useState } from "react";

import { K_COLORS_DARK_NAVY } from "../../constants";
import Link from "../../components/Link";
import globalStyles from "../../globalStyles";
import Section from "../../components/Section";
import { useWindowSize } from "../../hooks";
import { K_MOBILE_SIZE } from "../../constants";

const NotFoundPage = () => {
  const [isMoving, setIsMoving] = useState(false);

  const { width } = useWindowSize();
  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  const angleStyle = {
    transform: isMoving ? "translateX(5px)" : "translateX(0)",
    marginRight: "5px",
  };
  useEffect(() => {
    setTimeout(() => {
      setIsMoving(!isMoving);
    }, 500);
  }, [isMoving]);

  return (
    <Section style={styles.section}>
      <div>
        <div>
          <div>
            <span style={styles.titlePrimary}> 404 </span>
            <span style={styles.titleSecondary}>PageNotFound</span>
          </div>
          <div>
            <span style={styles.subtitle}>
              You seem like a curious wanderer..
            </span>
          </div>
          <div>
            <i
              className="fa fa-angle-double-right"
              style={{ ...styles.content, ...angleStyle }}
            />
            <span style={styles.content}> And a lost one too.. come </span>
            <Link target="/" style={styles.link} label="here" />
          </div>
        </div>
      </div>
    </Section>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.section,
    ...globalStyles.fullHeightSection,
    textAlign: "left",
    backgroundColor: K_COLORS_DARK_NAVY,
  },
  titlePrimary: {
    ...globalStyles.textMainSize,
    ...globalStyles.textDarkGreyColor,
  },
  titleSecondary: {
    ...globalStyles.textMainSize,
    ...globalStyles.textLightBlueColor,
  },
  subtitle: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textLightGreyColor,
  },
  content: {
    ...globalStyles.textNormalSize,
    ...globalStyles.textLightBlueColor,
    transition: "all 0.5s ease-out",
  },
  link: {
    ...globalStyles.textNormalSize,
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.section,
    ...globalStyles.fullHeightSection,
    textAlign: "left",
    backgroundColor: K_COLORS_DARK_NAVY,
  },
  titlePrimary: {
    ...globalStyles.textMainSize,
    ...globalStyles.textDarkGreyColor,
    lineHeight: "3.5rem",
  },
  titleSecondary: {
    ...globalStyles.textLargeSize,
    ...globalStyles.textLightBlueColor,
  },
  subtitle: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textLightGreyColor,
  },
  content: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textLightBlueColor,
    transition: "all 0.5s ease-out",
  },
  link: {
    ...globalStyles.textSmallSize,
  },
};

export default NotFoundPage;
